import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { RouterModule } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { TranslateService } from '@ngx-translate/core';
import { ChangeCcComponent } from '../change-cc/change-cc.component';
import { HousingReportComponent } from '../housing-report/housing-report.component';


@Component({
  selector: 'app-tour-prog-list',
  templateUrl: './tour-prog-list.component.html',
  styleUrls: ['./tour-prog-list.component.css']
})
export class TourProgListComponent implements OnInit {

  public menu_item_id = '91';
  public add_auth = false;
  public edit_auth = false;
  public del_auth = false;

  cat_list = [];

  private dp = [];
  displayedColumns = ['trip_number', 'trip_name', 'departure_date', 'arrival_date', 'visitors_number', 'registered_count',
    'prog_status', 'register', 'view', 'report', 'view_housing', 'edit', 'chagne_cc', 'copy', 'deactivate', 'cancel'];

  displayedColumns2 = ['trip_number', 'trip_name', 'departure_date', 'arrival_date', 'visitors_number', 'registered_count',
    'prog_status'];
  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  status_list = [{ 'status_id': 'ALL', 'status_name': 'الكل', 'status_name_en': 'All' },
    { 'status_id': '1', 'status_name': 'مفعل', 'status_name_en': 'Active' },
    { 'status_id': '0', 'status_name': 'غير مفعل', 'status_name_en': 'Inactive' }];

  active_list = [{ 'status_id': 'ALL', 'status_name': 'الكل', 'status_name_en': 'All' },
    { 'status_id': '1', 'status_name': 'الرحلات النشطة', 'status_name_en': 'Ingoing Programs' },
    { 'status_id': '0', 'status_name': 'الرحلات المؤرشفة', 'status_name_en': 'Archived Programs' }];

  model = {
    'table_name': 'trip', 'trip_name': '', 'trip_number': '', 'from_date': new Date(),
    'to_date': undefined, 'category_id': '0', 'prog_status': 'ALL', 'ret_from_date': undefined,
    'ret_to_date': undefined, 'active': 'ALL', 'title': 'البرامج السياحية'
  };

  changeDialogRef: MatDialogRef<ChangeCcComponent>;
  housingDialogRef: MatDialogRef<HousingReportComponent>;

  Success_Msg; Error_Msg; Del_Tour_Msg; Tourist_Programs_List; 
  Search_Msg;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    public dialog: MatDialog, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Del_Tour_Msg').subscribe((res: string) => {
      this.Del_Tour_Msg = res;
    });

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Tourist_Programs_List').subscribe((res: string) => {
      this.Tourist_Programs_List = res;
    });
    this.model['title'] = this.Tourist_Programs_List;

    translate.get('Search_Msg').subscribe((res: string) => {
      this.Search_Msg = res;
    });
  }

  ngOnInit() {
    if (this.applicationConstants.user_info['user_id'] != undefined) {
      this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
      this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);
      this.del_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.DELETE_AUTH);
    }
    else {
      this.displayedColumns = ['trip_number', 'trip_name', 'departure_date', 'arrival_date',
        'prog_status', 'register', 'view', 'report', 'view_housing'];  // , 'visitors_number', 'registered_count'
    }

    let date = new Date();
    this.model['from_date'] = new Date(date.getFullYear(), date.getMonth(), 1);
    let from_date = this.model['from_date'].getFullYear() + "-" + (this.model['from_date'].getMonth() + 1) + "-" + this.model['from_date'].getDate();
    
    // let query = "SELECT * FROM `category` WHERE `status` = '1'";
    let query = "SELECT DISTINCT`category`.`category_id`, `category`.`category_name`, `category`.`category_name_en` FROM " + 
      "`category`, `trip` WHERE `category`.`status` = '1' AND `category`.`category_id` = `trip`.`category_id` AND `trip`.`departure_date` >= '" + 
      from_date + "'" + (this.applicationConstants.user_info['user_id'] == undefined ? " AND (`trip`.`agent_only` = '1' OR `trip`.`agent_only` = '2')" : " AND (`trip`.`agent_only` = '0' OR `trip`.`agent_only` = '2')");  //  
    let obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        this.cat_list = data.data['list'];
        this.cat_list.unshift({ 'category_id': '0', 'category_name': 'الكل', 'category_name_en': 'All' });
      });

    // this.model['to_date'] = new Date(date.getFullYear(), date.getMonth() + 1, 0);

    // let ret_from_date = (new Date()).getFullYear() + "-" + ((new Date()).getMonth() + 1) + "-01";
    // let ret_to_date = (new Date()).getFullYear() + "-" + ((new Date()).getMonth() + 1) + "-31";
    // this.model['ret_from_date'] = new Date(date.getFullYear(), date.getMonth(), 1);
    // this.model['ret_to_date'] = new Date(date.getFullYear(), date.getMonth() + 1, 0);
  }

  changeDate() {
    let condition = "";
    if (this.model['from_date'] != undefined) {
      let from_date = this.model['from_date'].getFullYear() + "-" + (this.model['from_date'].getMonth() + 1) + "-" + this.model['from_date'].getDate();
      condition += " AND `trip`.`departure_date` >= '" + from_date + "'";
    }
    if (this.model['to_date'] != undefined) {
      let to_date = this.model['to_date'].getFullYear() + "-" + (this.model['to_date'].getMonth() + 1) + "-" + this.model['to_date'].getDate();
      condition += " AND `trip`.`departure_date` <= '" + to_date + "'";
    }
    if (this.model['ret_from_date'] != undefined) {
      let ret_from_date = this.model['ret_from_date'].getFullYear() + "-" + (this.model['ret_from_date'].getMonth() + 1) + "-" + this.model['ret_from_date'].getDate();
      condition += " AND `trip`.`arrival_date` >= '" + ret_from_date + "'";
    }
    if (this.model['ret_to_date'] != undefined) {
      let ret_to_date = this.model['ret_to_date'].getFullYear() + "-" + (this.model['ret_to_date'].getMonth() + 1) + "-" + this.model['ret_to_date'].getDate();
      condition += " AND `trip`.`arrival_date` <= '" + ret_to_date + "'";
    }

    let query = "SELECT DISTINCT`category`.`category_id`, `category`.`category_name`, `category`.`category_name_en` FROM " + 
      "`category`, `trip` WHERE `category`.`status` = '1' AND `category`.`category_id` = `trip`.`category_id` " + condition + 
      (this.applicationConstants.user_info['user_id'] == undefined ? " AND (`trip`.`agent_only` = '1' OR `trip`.`agent_only` = '2')" : " AND (`trip`.`agent_only` = '0' OR `trip`.`agent_only` = '2')"); 
    let obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        this.cat_list = data.data['list'];
        this.cat_list.unshift({ 'category_id': '0', 'category_name': 'الكل', 'category_name_en': 'All' });
      });
  }

  changeActivity() {
    this.model['active'] = ((document.getElementById('active') as HTMLInputElement).checked ? '1' : '0');
  }

  search() {
    if (this.model['trip_number'] == '' && this.model['trip_name'] == '' && 
      this.model['category_id'] == '0' && this.model['from_date'] == undefined && 
      this.model['to_date'] == undefined && this.model['prog_status'] == 'ALL' && 
      this.model['ret_from_date'] == undefined && this.model['ret_to_date'] == undefined && 
      this.model['active'] == 'ALL') {
      alert(this.Search_Msg);
      return;
    }

    let obj = { cmd: 'getTripList' };

    if (this.applicationConstants.user_info['user_id'] == undefined)
      obj['agent_only'] = true;

    if (this.model['trip_number'] != '')
      obj['trip_number'] = this.model['trip_number'];

    if (this.model['trip_name'] != '')
      obj['trip_name'] = this.model['trip_name'];
    
    if (this.model['category_id'] != '0')
      obj['category_id'] = this.model['category_id'];

    if (this.model['from_date'] != undefined) 
      obj['from_date'] = this.model['from_date'].getFullYear() + "-" + (this.model['from_date'].getMonth() + 1) + "-" + this.model['from_date'].getDate();

    if (this.model['to_date'] != undefined) 
      obj['to_date'] = this.model['to_date'].getFullYear() + "-" + (this.model['to_date'].getMonth() + 1) + "-" + this.model['to_date'].getDate();

    if (this.model['prog_status'] != 'ALL')
      obj['prog_status'] = this.model['prog_status'];

    if (this.model['ret_from_date'] != undefined) 
      obj['ret_from_date'] = this.model['ret_from_date'].getFullYear() + "-" + (this.model['ret_from_date'].getMonth() + 1) + "-" + this.model['ret_from_date'].getDate();

    if (this.model['ret_to_date'] != undefined) 
      obj['ret_to_date'] = this.model['ret_to_date'].getFullYear() + "-" + (this.model['ret_to_date'].getMonth() + 1) + "-" + this.model['ret_to_date'].getDate();

    if (this.model['active'] != 'ALL') 
      obj['active'] = this.model['active'];
  
    this.utils.invokeHttp(this.applicationConstants.tourismFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        console.log(data);

        this.dp = data.data['list'];
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });

  }

  print() {
    let html_data = '';
    let form = (document.getElementById('form1') as HTMLFormElement);

    html_data = '<table cellpadding="8" cellspacing="0">';
    html_data += '<tr><td width="33%"> ' + this.Tourist_Programs_List + '</td></tr>';
    html_data += '</table>';

    let table = (document.getElementById('prog_table2') as HTMLTableElement);
    html_data += this.utils.printReport(html_data, [{ table: table }], form, 'PDF');
  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title);
  }

  viewHotelRoom(row) {
    let dialog_data = [{
      'table_name': 'trip', 'trip_id': row.trip_id
    }];

    this.housingDialogRef = this.dialog.open(HousingReportComponent, {
      hasBackdrop: false,
      data: dialog_data
    });
    this.housingDialogRef
      .afterClosed()
      .subscribe(result => {
        // if (result != null && result['op_type'] == 'success') {
        //   this.search();
        // }
      });
  }

  changeCC(row) {
    let dialog_data = [{
      'table_name': 'trip', 'id': row.trip_id, 'cost_center': row.cost_center 
    }];

    this.changeDialogRef = this.dialog.open(ChangeCcComponent, {
      hasBackdrop: false,
      data: dialog_data
    });
    this.changeDialogRef
      .afterClosed()
      .subscribe(result => {
        // if (result != null && result['op_type'] == 'success') {
        //   this.search();
        // }
      });
  }

  deactivate(row) {
    let values = [{ 'table_name': this.model['table_name'], 'active': '0' }];
    let where = [{ 'trip_id': row.trip_id }];
    let obj = { cmd: 'update', values: values, where: where };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        if (data.status['type'] == 'success') {
          alert(this.Success_Msg);
          this.search();
        }
        else
          alert(this.Error_Msg);
      });
  }

  cancel(row) {
    if (confirm(this.Del_Tour_Msg)) {
      let obj;

      let values = [];
      values.push({ 'table_name': this.model['table_name'], 'trip_id': row.trip_id });
      values.push({ 'table_name': 'trip_city', 'trip_id': row.trip_id });
      values.push({ 'table_name': 'trip_bus', 'trip_id': row.trip_id });
      values.push({ 'table_name': 'trip_room_price', 'trip_id': row.trip_id });

      let query = "SELECT `invoice_no` FROM `invoice` WHERE `trip_id` = '" + row.trip_id + "'";
      obj = { cmd: 'getList', query: query };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          let invoice_list = data.data['list'];

          invoice_list.forEach(element => {
            values.push({ 'table_name': 'invoice', 'invoice_no': element.invoice_no });
            values.push({ 'table_name': 'invoice_item', 'invoice_no': element.invoice_no });
            values.push({ 'table_name': 'inv_payment_method', 'invoice_no': element.invoice_no });
            values.push({ 'table_name': 'trip_group', 'invoice_no': element.invoice_no });
            values.push({ 'table_name': 'reg_on_hotel', 'invoice_no': element.invoice_no });
            values.push({ 'table_name': 'cash_receipt_invoice', 'invoice_no': element.invoice_no });
          });

          obj = { cmd: 'deleteRec', values: values };
          this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
            .subscribe(data => {
              this.applicationConstants.appComp.hideBusyCursor();
              if (data.status['type'] == 'success') {
                alert(this.Success_Msg);
                this.search();
              }
              else {
                alert(this.Error_Msg);
              }
            });
        });
    }
  }

}
